<template>
    <div class="hello">
       <header>
        <h1>Sweet定位-用户协议</h1>
        <p>最近更新日期：2025年10月29日</p>
       </header>
        <section>
          <h2>一、重要提示</h2>
          <p>1.1 Sweet定位运营方重庆盛纳科技有限公司（以下简称“我们”）同意按照本协议规定、以及后续发布的所有操作规则向您提供Sweet定位服务。为获得服务，您需认真阅读并认可本协议全部条款，当您完成注册程序即视为完全接受本协议。如您对协议有异议，应终止注册或停止使用服务。</p>
           <p>1.2 您注册成功后，我们将为您开通Sweet定位服务，此时您会同意：</p>
           <ul>
            <li>(1)妥善保管自己的账号及密码，对账号使用行为及发布信息承担全部责任；</li>
            <li>(2)账号不得擅自买卖、转让、出租；</li>
            <li>(3)可通过设置功能控制信息公开方式和可见范围。</li>
           </ul>
            <p>1.3 您对发布的内容（文字、图片、定位信息等）享有合法权利，同时您会同意：</p>
            <ul>
              <li>(1)我们对您发布的内容享有使用权，用于服务优化和推广；</li>
               <li>(2)未经书面许可，不得非法抓取所有平台内容；</li>
                <li>(3)严格遵守《Sweet定位-用户协议》，不得违规访问平台或收集内容。</li>
            </ul>
             <p>1.4 若您是未成年人，须在监护人陪同下阅读本协议，经监护人同意后方可使用，其使用服务的行为视为已获监护人认可。</p>
             <h2>二、服务内容</h2>
             <p>2.1 服务范围：我们提供定位共享、轨迹记录、动态提醒、互动聊天、今日报告等核心服务，具体内容可根据实际情况进行升级调整，并及时更新告知。</p>
               <p>2.2 收费服务：部分增值服务（如30天足迹、动态提醒、今日报告、恢复近90天聊天记录等）需支付费用，我们会在您使用前明确提示收费标准，您确认支付后方可使用。</p>
                 <p>2.3 设备要求：您需自行配备兼容设备并承担网络费用（如流量费、话费），因设备或网络问题导致的服务异常，我们不承担责任。</p>
                   <p>2.4 定位服务说明：</p>
                   <ul>
                    <li>(1)定位功能基于手机定位模块及高德地图SDK实现，需您授予“始终允许定位”；</li>
                    <li>(2)定位准确性受网络环境、设备性能、地理位置等因素影响，存在合理误差，您应自行判断使用；</li>
                    <li>(3)位置信息仅在您与绑定人之间共享，我们会采取加密技术保护数据传输。</li>
                   </ul>
                   <h2>三、服务变更、中断或终止</h2>
                   <p>3.1 因网络服务特性（如服务器故障、网络攻击等），我们有权中断或终止部分/全部服务，将通过网页公告、系统通知等方式及时告知。</p>
                   <p>3.2 定期维护：我们可能对平台或设备进行检修维护，合理时间内的服务中断无需承担责任，但会提前通告。</p>
                   <p>3.3 出现以下情形我们可中断或终止服务且不承担责任：</p>
                   <ul>
                    <li>(1)提供虚假个人资料；</li>
                    <li>(2)违反法律法规、本协议使用规则；</li>
                    <li>(3)未支付收费服务费用；</li>
                    <li>(4)侵犯他人合法权益（包括知识产权、隐私权等）；</li>
                    <li>(5)损害国家机关形象或平台商誉；</li>
                    <li>(6)其他合理理由。</li>
                   </ul>
                   <p>3.4 账号长期未使用（连续 180 日），我们有权回收昵称、账号或停止服务。</p>
                   <p>3.5 第三方账号绑定解除：若您违反协议、第三方规定，或第三方要求解除绑定，我们可解除绑定且不承担责任。</p>
                   <h2>四、使用规则</h2>
                   <p>4.1 账号信息规范：</p>
                   <ul>
                    <li>(1)注册时需提供真实身份信息（如手机号），个人资料变动应及时更新；</li>
                     <li>(2)账号昵称等不得含违法或不良信息，不得以虚假身份注册；</li>
                   </ul>
                   <p>4.2 禁止行为：</p>
                   <ul>
                    <li>(1)转让、出借账号或密码，因保管不当导致的账号安全问题由您负责；</li>
                    <li>(2)实施自动化行为（如批量操作、高频互动）或发布垃圾信息（营销、无意义内容）；</li>
                    <li>(3)伪造定位信息、恶意追踪他人或滥用定位功能；</li>
                    <li>(4)上传违法内容（如色情、暴力、诽谤信息）或从事危害平台安全的行为。</li>
                   </ul>
                   <p>4.3 信息保护与备份：</p>
                   <ul>
                    <li>(1)我们建立信息安全管理制度，保护您的隐私内容；</li>
                    <li>(2)建议您定期备份重要数据，账号注销或服务终止后，无法返还任何数据。</li>
                   </ul>
                   <p>4.4 广告与信息推送：您同意我们在平台投放商业广告，并通过邮件、通知等方式发送促销信息。</p>
                   <p>4.5 内容授权：您授权我们在平台及关联产品中使用您发布的内容，用于宣传推广，此授权不改变内容所有权归属。</p>
                   <p>4.6 行为规范：您应文明使用服务，尊重他人权益，共同维护良好网络环境。</p>
                   <p>4.7 我们有权审查您的信息、内容及行为，依据后台记录判断是否违规并采取处理措施。</p>
                   <p>4.8 举报机制：发现违法侵权内容可点击“投诉”或联系客服邮箱<b>sweet_9966@126.com</b>，我们会核实处理；涉及人身权益纠纷可参照平台公告方式处理，必要时可向司法机关求助，我们将依法配合调查。</p>
                   <h2>五、知识产权</h2>
                   <p>5.1 我们是平台和产品的所有权及知识产权权利人，包括但不限于程序代码、界面设计、功能模块、数据资料等。</p>
                   <p>5.2 您发布的内容知识产权归您所有，但授予我们免费、非独家使用权，用于服务优化和推广。</p>
                   <p>5.3 第三方功能/软件：平台可能包含第三方开发的功能或服务，您需遵守第三方规定并尊重其知识产权。</p>
                   <p>5.4 禁止行为：未经许可不得对平台功能、软件进行反向工程、编译或汇编，不得擅自发布、传播平台内容。</p>
                   <h2>六、隐私保护</h2>
                   <p>6.1 我们尊重您的隐私，具体保护措施详见《Sweet定位-隐私政策》，该政策为本协议不可分割的部分。</p>
                    <p>6.2 您有权通过账号设置或联系客服删除个人信息，账号注销后相关数据将按规定处理。</p>
                    <h2>七、免责声明</h2>
                    <p>7.1 您对使用服务的行为及发布内容承担全部责任，平台内容仅为用户分享，不代表平台立场。</p>
                    <p>7.2 外部链接：平台可能包含第三方链接，我们不对其内容准确性和完整性负责。</p>
                    <p>7.3 不可抗力：因不可抗力或无法控制的原因（如服务器故障、黑客攻击）导致的服务中断或损失，我们不承担责任。</p>
                    <p>7.4 第三方合作：与第三方合作提供的产品/服务，由第三方承担质量及纠纷责任，您应向第三方主张权利。</p>
                    <p>7.5 服务期限：未标明使用期限或标为“永久”的产品/服务，使用期限至该功能下线之日止。</p>
                    <h2>八、违约责任</h2>
                    <p>8.1 我们违反协议给您造成损失的，承担相应损害赔偿责任。</p>
                    <p>8.2 您违反协议给我们或第三方造成损失的，应承担全部赔偿责任。</p>
                    <p>8.3 发现您违规时，我们有权不经通知采取必要措施（如删除内容、账号禁言、限制功能、注销账号等），由此造成的损失由您自行承担。</p>
                    <h2>九、协议修改</h2>
                    <p>9.1 我们有权修改协议条款，修改后将在平台公布，您继续使用服务即视为接受修改。</p>
                     <p>9.2 不同意修改可停止使用服务，若继续使用则视为认可新条款。</p>
                     <h2>十、通知送达</h2>
                     <p>10.1 我们的通知可能通过网页公告、电子邮件、系统通知、短信等方式发送，发送/公布之日视为送达。</p>
                      <p>10.2 针对我们的通知若您需要回应，可通过我们对外公布的邮箱地址与我们进行联系。邮箱如下：<b>sweet_9966@126.com</b></p>
                      <h2>十一、法律适用</h2>
                      <p>11.1 本协议适用中华人民共和国大陆地区法律。</p>
                       <p>11.2 若双方就本协议内容或其执行发生任何争议，双方尽量友好协商解决；友好协商不成的，任何一方可向Sweet定位住所地有管辖权的人民法院提起诉讼。</p>
                       <h2>十二、未成年人使用条款</h2>
                       <p>12.1 未满 18 周岁用户应在监护人指导下使用服务，监护人需同意本协议。</p>
                       <p>12.2 未成年人使用注意事项：</p>
                       <ul>
                        <li>(1)避免沉迷网络影响学习生活；</li>
                         <li>(2)谨慎填写个人资料，防止信息泄露；</li>
                          <li>(3)在监护人指导下使用定位功能，不与陌生网友会面；</li>
                           <li>(4)监护人应加强引导，关注子女使用情况。</li>
                       </ul>
                       <p>12.3 无完全民事行为能力的成年人参照本条款执行。</p>
                       <h2>十三、其他</h2>
                       <p>13.1 本协议标题仅为阅读方便，不影响条款解释。</p>
                        <p>13.2 本协议未尽事宜，参照《Sweet定位-隐私政策》及相关法律法规执行。</p>
                         <p>13.3 本协议自您注册使用服务之日起生效，具有法律约束力。</p>
        </section>
    </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px
}
.hello{
  margin:20px;
}
section{
  padding-bottom:20px;
}
h1 {
  font-size: 18px;
  margin: 10px 0;
}

h2 {
  margin: 10px 0;
  font-size: 14px
}


li {
  margin: 10px 0;
  list-style: none;
}


p {
  margin: 10px 0;
}

.tab {
  table-layout: fixed;
  text-align: left;
  width: 100%;
  border-collapse: collapse;
}

.tab tr {
  width: 100%;
}

.tab th {
  padding: 0 4px;
}

.tab td {
  width: 25%;
  padding: 0 4px;
  word-break: break-all;
}

.link {
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue